
<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <kendo-panelbar (expand)="onPanelBarSelect($event)" #panelbar>
      <kendo-panelbar-item id="modSchInfo" title="{{moduleLblText.modulesSchoolInformationLbl?moduleLblText.modulesSchoolInformationLbl:modulesSchool.modulesSchoolInformationLbl}}"
                           [expanded]="true">
        <ng-template kendoPanelBarContent>
          <div class="row m-top left">
            <div class="col-sm-12">
              <kendo-tabstrip [scrollable]="true" [tabPosition]="position" (tabSelect)="onTabSelected($event)" class="k-tabstrip">
                <kendo-tabstrip-tab title="{{moduleLblText.trainingModuleDescriptionLbl?moduleLblText.trainingModuleDescriptionLbl:modulesSchool.trainingModuleDescriptionLbl}}" [selected]="true">
                  <ng-template kendoTabContent>
                    <div class="form-group">
                      <h5 [innerHTML]="data?.trainingName"></h5>
                    </div>
                    <div class="form-group">
                      <p [innerHTML]="data?.trainingDescription"></p>
                      <div class="myIframe" *ngIf="trainingPdfUrl">
                        <iframe [src]="secureUrl"
                                type="application/pdf"></iframe>
                      </div>
                    </div>
                   
                    <div class="form-group" *ngFor="let list of data?.modulesList">
                      <h6>{{list.moduleName}} - {{list.moduleShortDescription}}</h6>
                      <p>{{list.modulesDescription}}</p>
                      <p>{{list.startDate| date : "MM/dd/yyyy"}} - {{list.endDate| date : "MM/dd/yyyy"}}</p>
                      <p>{{list.price|currency}}</p><p>{{list.totalSeats}} Seats</p>
                      <div class="form-group" *ngFor="let subList of list.moduleSchoolLocationList">
                        <h6>{{subList.locationName}}</h6>
                        <p>{{subList.locationDescription}}</p>
                        <p>{{subList.startDate| date : "MM/dd/yyyy"}} - {{subList.endDate| date : "MM/dd/yyyy"}}</p>
                      </div>
                      <hr />
                    </div>
                    <!--<div class="form-group" *ngFor="let list of data?.moduleSchoolLocationDetails">
                      <p>{{list.locationName}}</p>
                      <p>{{list.locationDescription}}</p>
                      <p>{{list.startDate| date : "MM/dd/yyyy"}} - {{list.endDate| date : "MM/dd/yyyy"}}</p>-->
                    <!--add module related list here if required-->
                    <!--</div>-->
                  </ng-template>
                </kendo-tabstrip-tab>

                <kendo-tabstrip-tab title="{{moduleLblText.locationInformationLbl?moduleLblText.locationInformationLbl:modulesSchool.locationInformationLbl}}">
                  <ng-template kendoTabContent>
                    <div class="form-group" *ngFor="let list of data?.moduleSchoolLocationDetails">
                      <h6>{{list.locationName}} - {{list.moduleShortDescription}}</h6>
                      <p>{{list.locationDescription}} </p>
                      <p>{{list.startDate| date : "MM/dd/yyyy"}} - {{list.endDate| date : "MM/dd/yyyy"}}</p>
                      <p>{{list.price|currency}}</p>
                      <p>Total Seats- {{list.totalSeats}}</p>
                      <p>Available Seats- {{list.availableSeats < 0 ? 0 : list.availableSeats }}</p>
                      <!--add more here if required-->
                    </div>
                    <p>{{moduleLblText.moduleNote?moduleLblText.moduleNote:modulesSchool.moduleNote}}</p>
                  </ng-template>
                </kendo-tabstrip-tab>

                <!--<kendo-tabstrip-tab title="{{moduleLblText.registrationLbl?moduleLblText.registrationLbl:modulesSchool.registrationLbl}}">
                  <ng-template kendoTabContent>
                    <p [innerHTML]="data?.registrationDescription"></p>
                    <div class="myIframe" *ngIf="registrationPdfUrl">
                      <iframe [src]="registrationPdfUrl"
                              type="application/pdf"></iframe>
                    </div>
                  </ng-template>
                </kendo-tabstrip-tab>-->
                <kendo-tabstrip-tab title="{{moduleLblText.liabilityWaiverLbl?moduleLblText.liabilityWaiverLbl:modulesSchool.liabilityWaiverLbl}}">
                  <ng-template kendoTabContent>
                    <div class="col-sm-12">
                      <span class="k-icon k-i-file-pdf"></span><!--<a href="{{pdfUrl}}" target="_blank">{{moduleLblText.pdfLinkLbl?moduleLblText.pdfLinkLbl:modulesSchool.pdfLinkLbl}}</a>-->
                    <a href="javascript:void(0)" (click)="openDocument(pdfUrl)">{{moduleLblText.pdfLinkLbl?moduleLblText.pdfLinkLbl:modulesSchool.pdfLinkLbl}}</a>
</div>
                  </ng-template>
                </kendo-tabstrip-tab>
              </kendo-tabstrip>
            </div>
          </div>
          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToNextPanel()">
              {{moduleLblText.continueLbl?moduleLblText.continueLbl:modulesSchool.continueLbl}}
            </button>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item id="onReg" title="{{moduleLblText.onlineRegistrationLbl?moduleLblText.onlineRegistrationLbl:modulesSchool.onlineRegistrationLbl}}"
                           [expanded]="false">
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-0 col-md-0 col-lg-1"></div>
            <div class="col-sm-12 col-md-12 col-lg-10 paddingZero">
              <form [formGroup]="registrationForm">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.firstNameLbl?moduleLblText.firstNameLbl:modulesSchool.firstNameLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="firstName"
                             class="kendoInput" [ngClass]="{'borderRed':modulesSchool.isEmptyFirstName && modulesSchool.isSubmitted}"
                             (blur)="validateModulesSchoolForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.lastNameLbl?moduleLblText.lastNameLbl:modulesSchool.lastNameLbl}}</label>
                      <input type="text" kendoTextBox formControlName="lastName"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.jobTitleLbl?moduleLblText.jobTitleLbl:modulesSchool.jobTitleLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="jobTitle"
                             class="kendoInput" [ngClass]="{'borderRed':modulesSchool.isEmptyJobTitle && modulesSchool.isSubmitted}"
                             (blur)="validateModulesSchoolForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.companyNameLbl?moduleLblText.companyNameLbl:modulesSchool.companyNameLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="companyName"
                             class="kendoInput" [ngClass]="{'borderRed':modulesSchool.isEmptyCompanyName && modulesSchool.isSubmitted}"
                             (blur)="validateModulesSchoolForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.addressLbl?moduleLblText.addressLbl:modulesSchool.addressLbl}}</label>
                      <input type="text" kendoTextBox formControlName="address"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.cityLbl?moduleLblText.cityLbl:modulesSchool.cityLbl}}&nbsp;&nbsp;</label>
                      <input type="text" kendoTextBox formControlName="city"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.commentLbl?moduleLblText.commentLbl:modulesSchool.commentLbl}}</label>
                      <textarea kendoTextArea class="kendoInput"
                                formControlName="comments"></textarea>
                    </div>
                    <h6>{{moduleLblText.selectModuleLbl?moduleLblText.selectModuleLbl:modulesSchool.selectModuleLbl}}:</h6>
                    <div class="form-group" *ngFor="let list of data?.moduleSchoolLocationDetails">
                      <kendo-switch name="selectModule" class="switch-control" [onLabel]="'Yes'" [offLabel]="'No'" (click)="modulesCheck(list)">
                      </kendo-switch>
                      <label class="switch-label" [for]="selectModule"><b>{{list.locationName}}</b><br /><p>{{list.startDate| date : "MM/dd/yyyy"}} - {{list.endDate| date : "MM/dd/yyyy"}}</p></label>
                      <span title="{{moduleLblText.invalidLocation?moduleLblText.invalidLocation:modulesSchool.invalidLocation}}" *ngIf="modulesSchool.isInvalidLocation" kendoTooltip
                            class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.emailLbl?moduleLblText.emailLbl:modulesSchool.emailLbl}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="email"
                             class="kendoInput" [ngClass]="{'borderRed':(modulesSchool.isEmptyEmail || modulesSchool.isInvalidEmail) && modulesSchool.isSubmitted}"
                             (blur)="emailLeave()" />
                      <span title="{{moduleLblText.invalidEmail?moduleLblText.invalidEmail:modulesSchool.invalidEmail}}" *ngIf="modulesSchool.isInvalidEmail" kendoTooltip
                            class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>

                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.phoneNumber?moduleLblText.phoneNumber:modulesSchool.phoneNumber}}<span class="requiredField">*</span></label>
                      <kendo-numerictextbox formControlName="phoneNumber" [maxlength]="10"
                                            [format]="'#'" [spinners]="false"
                                            class="kendoInput" [ngClass]="{'borderRed':modulesSchool.isEmptyPhoneNumber && modulesSchool.isSubmitted}"
                                            (blur)="validateModulesSchoolForm()"></kendo-numerictextbox>
                      <span title="{{moduleLblText.invalidPhoneLbl?moduleLblText.invalidPhoneLbl:modulesSchool.invalidPhoneLbl}}"
                            *ngIf="modulesSchool.isInvalidPhoneNumber" kendoTooltip
                            class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.faxNumberLbl?moduleLblText.faxNumberLbl:modulesSchool.faxNumberLbl}}</label>
                      <input type="text" kendoTextBox formControlName="faxNumber"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.countryLbl?moduleLblText.countryLbl:modulesSchool.countryLbl}}</label>
                      <kendo-dropdownlist [data]="countries" kendoTextBox class="kendoInput" [textField]="'countryName'"
                                          [valueField]="'countryCode'" name="country" formControlName="country"
                                          (selectionChange)="countySelectionChange($event)"
                                          [valuePrimitive]="true">
                      </kendo-dropdownlist>
                    </div>

                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.stateLbl?moduleLblText.stateLbl:modulesSchool.stateLbl}}</label>
                      <kendo-dropdownlist class="kendoInput"
                                          formControlName="state"
                                          [ngModel]="{stateDescription:selectedState,stateCode:selectedState}"
                                          [data]="states"
                                          [textField]="'stateDescription'"
                                          [valueField]="'stateCode'">
                      </kendo-dropdownlist>
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{moduleLblText.zipCodeLbl?moduleLblText.zipCodeLbl:modulesSchool.zipCodeLbl}}</label>
                      <input type="text" kendoTextBox formControlName="zipCode"
                             class="kendoInput" maxlength="10" />
                    </div>
                  </div>

                  <!--<div class="col-sm-12">
                    {{moduleLblText.onlineRegistrationNote?moduleLblText.onlineRegistrationNote:modulesSchool.onlineRegistrationNote}}
                  </div>-->
                </div>
              </form>
              <div class="d-flex justify-content-center col-xs-12 col-sm-12">
                <button kendoButton
                        (click)="resetForm()" [disabled]="saveInProcess" class="m-3" primary="true">
                  {{moduleLblText.cancelLbl?moduleLblText.cancelLbl:modulesSchool.cancelLbl}}
                </button>
                <button kendoButton
                        (click)="submit()" [disabled]="saveInProcess" class="m-3" primary="true">
                  {{moduleLblText.submitLbl?moduleLblText.submitLbl:modulesSchool.submitLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>
            </div>
            <div class="col-sm-0 col-md-0 col-lg-1"></div>

          </div>

        </ng-template>
      </kendo-panelbar-item>

    </kendo-panelbar>
  </div>

</div>
